<template>
  <span
    :aria-label="$bct('required')"
    :class="fontSize"
    class="c-red"
  >
    *
  </span>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  size: {
    type: String,
    default: '16',
  },
});

const fontSize = computed(() => {
  return props.size === 'inherit' ? 'fs-inherit' : `fs-${props.size}`;
});
</script>
